import config from "@config"
import PagesContext from "@src/context/pagesContext"
import throttle from "lodash/throttle"
import React, { useEffect, useState } from "react"
import { animated, useSpring, useTransition } from "react-spring"
import { pageJoinData } from "./pageJoin"
import * as styles from "./pages.module.scss"
import { pageTotalData } from "./pageTotal"
import { pageWelcomeData } from "./pageWelcome"
import { pageMostAlbumsData } from "./pageMostAlbums"
// import { pageMostCollectionsData } from "./pageMostCollections"
import { pageMostRadioData } from "./pageMostRadio"
import { pageNightData } from "./pageNight"
import { pageLikesData } from "./pageLikes"
import { pageLikedData } from "./pageLiked"
import { pagePublishData } from "./pagePublish"
import { pageEndData } from "./pageEnd"
import { pageBooomData } from "./pageBooom"
import { pageCompareData } from "./pageCompare"

// const pagesData = [pagePublishData]
const pagesData = [
  pageWelcomeData,
  pageJoinData,
  pageTotalData,
  pageCompareData,
  pageMostAlbumsData,
  pageMostRadioData,
  pageNightData,
  pageLikesData,
  pagePublishData,
  pageLikedData,
  pageBooomData,
  pageEndData,
]

const pageStatus = (index, current) => {
  if (index === current) {
    return "active"
  }

  return index < current ? "prev" : "next"
}

const filterPages = (data, pagesData) => {
  return pagesData.filter(({ key, shouldHide }) => {
    if (key === "welcome") {
      return true
    }
    // 保证除欢迎页外，每页都有数据
    if (!data?.loaded) {
      return false
    }
    return shouldHide ? !shouldHide(data) : true
  })
}

const initialIndex = 0
const Pages = ({ data, isMobile }) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex)
  const filteredPages = filterPages(data, pagesData)
  const pageData = filteredPages[currentIndex] || {}
  const { bgColor } = useSpring({
    bgColor: pageData.bg,
    delay: pageData.delay || config.pageDelay,
    from: {
      bgColor: filteredPages[initialIndex].bg || "#fff",
    },
  })
  const pageBgStyles = useTransition([pageData], {
    delay: pageData.delay || config.pageDelay,
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    keys: (p) => p.key,
  })

  useEffect(() => {
    const set = throttle(
      (delta) => {
        setCurrentIndex((cur) => {
          const next = delta < 0 ? cur - 1 : cur + 1
          const n = Math.max(Math.min(next, filteredPages.length - 1), 0)
          return n
        })
      },
      2000,
      { trailing: false, leading: true }
    )

    // mouse wheel

    const mousewheelevt = /Firefox/i.test(navigator.userAgent)
      ? "DOMMouseScroll"
      : "mousewheel"

    const wheelEvent = (e) => {
      const delta = e.detail ? e.detail : e.deltaY
      set(delta)
    }

    window.addEventListener(mousewheelevt, wheelEvent)

    // touch

    let ts
    const moveMin = 10
    const touchstart = (e) => {
      ts = e.touches[0].clientY
    }
    const touchmove = (e) => {
      var te = e.changedTouches[0].clientY
      const offset = te - ts
      if (typeof ts === "number" && Math.abs(offset) >= moveMin) {
        ts = null
        set(offset > 0 ? -1 : 1)
      }
      e.preventDefault()
    }
    document.documentElement.addEventListener("touchstart", touchstart)
    document.documentElement.addEventListener("touchmove", touchmove, {
      passive: false,
    })

    // keyboard

    const keyEvent = (e) => {
      const c = e.keyCode
      if ([40, 39].includes(c)) {
        set(1)
      } else if ([37, 38].includes(c)) {
        set(-1)
      }
    }
    document.documentElement.addEventListener("keydown", keyEvent)

    return () => {
      window.removeEventListener(mousewheelevt, wheelEvent)
      document.documentElement.removeEventListener("touchstart", touchstart)
      document.documentElement.removeEventListener("touchmove", touchmove)
      document.documentElement.removeEventListener("keydown", keyEvent)
    }
  }, [filteredPages.length])

  const bg = (
    <div className={styles.bg}>
      <animated.div
        className={styles.bgMask}
        style={{ backgroundColor: bgColor }}
      />
      {pageBgStyles((props, item) => (
        <animated.div style={props} className={styles.bgPage}>
          {item.bgImg && (
            <img src={item.bgImg} alt="bg" className={styles.bgImg} />
          )}
          {item.bgElement}
        </animated.div>
      ))}
      {/* <div className={styles.bgAnimationContainer}>
        <div className={styles.bgAnimationInner}>
          <LottieControl
            animationData={bgJson}
            className={styles.bgAnimation}
            delayMount
          />
        </div>
      </div> */}
    </div>
  )

  return (
    <PagesContext.Provider
      value={{
        returnToFirst: () => {
          setCurrentIndex(0)
        },
        next: () => {
          setCurrentIndex((i) => i + 1)
        },
      }}
    >
      <div className={styles.fullscreen}>
        <div className={styles.pagesFrame}>
          <div className={styles.pagesContainer} id="pages">
            {bg}
            {filteredPages.map(({ key, Page, theme, pageProps }, i) => {
              const isActive = currentIndex === i
              return (
                <Page
                  key={key}
                  pageName={key}
                  data={data}
                  isLastPage={i === filteredPages.length - 1}
                  status={pageStatus(i, currentIndex)}
                  active={isActive}
                  theme={theme}
                />
              )
            })}
          </div>
        </div>
      </div>
    </PagesContext.Provider>
  )
}

export default Pages
